import {
  CLEAR_NEWS,
  CLEAR_STATE,

  DELETE_NEWS,
  DELETE_NEWS_ERROR,
  DELETE_NEWS_SUCCESS,

  DELETE_MAIN_IMAGE,
  DELETE_MAIN_IMAGE_SUCCESS,
  DELETE_MAIN_IMAGE_ERROR,

  DELETE_SUB_IMAGE,
  DELETE_SUB_IMAGE_ERROR,
  DELETE_SUB_IMAGE_SUCCESS,

  GET_NEWS,
  GET_NEWS_ERROR,
  GET_NEWS_SUCCESS,

  GET_ALL_NEWS,
  GET_ALL_NEWS_ERROR,
  GET_ALL_NEWS_SUCCESS,

  SAVE_NEWS,
  SAVE_NEWS_ERROR,
  SAVE_NEWS_SUCCESS,

  CREATE_NEWS,
  CREATE_NEWS_ERROR,
  CREATE_NEWS_SUCCESS,

  GET_CATEGORY,
  GET_CATEGORY_ERROR,
  GET_CATEGORY_SUCCESS,

  DELETE_CATEGORY,
  DELETE_CATEGORY_ERROR,
  DELETE_CATEGORY_SUCCESS,

  CREATE_CATEGORY,
  CREATE_CATEGORY_ERROR,
  CREATE_CATEGORY_SUCCESS,

  GET_CATEGORY_BYID,
  GET_CATEGORY_BYID_ERROR,
  GET_CATEGORY_BYID_SUCCESS,

} from './constants';

export default {
  [CREATE_NEWS](state) {
    state.error = false;
    state.success = false;
    state.exportSuccess = false;
    state.exportLoading = false;
    state.loading = false;
    state.preventNew = false;
    state.allnews = [];
    state.news = false;
  },
  [CLEAR_NEWS](state) {
    state.news = {
      title: null,
      description: null,
      content: null,
      createdBy: null,
      createdByName: null,
      mainImage: null,
      subImages: null,
      syndicateID: null,
      categorieId: '',
      categorieName: null,
    };
  },

  [CLEAR_STATE](state) {
    state.error = false;
    state.success = false;
  },

  [DELETE_NEWS](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DELETE_NEWS_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [DELETE_NEWS_SUCCESS](state) {
    state.success = true;
    state.allnews = false;
    state.loading = false;
  },

  [DELETE_CATEGORY](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DELETE_CATEGORY_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [DELETE_CATEGORY_SUCCESS](state) {
    state.success = true;
    state.category = false;
    state.loading = false;
  },

  [DELETE_MAIN_IMAGE](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DELETE_MAIN_IMAGE_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_MAIN_IMAGE_SUCCESS](state) {
    state.success = true;
    state.transaction = false;
    state.loading = false;
  },

  [DELETE_SUB_IMAGE](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DELETE_SUB_IMAGE_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_SUB_IMAGE_SUCCESS](state) {
    state.success = true;
    state.transaction = false;
    state.loading = false;
  },

  [GET_NEWS](state) {
    state.news = false;
    state.error = false;
    state.loading = true;
  },
  [GET_NEWS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_NEWS_SUCCESS](state, payload) {
    state.news = payload;
    state.loading = false;
  },

  [GET_CATEGORY](state) {
    state.category = false;
    state.error = false;
    state.loading = true;
  },
  [GET_CATEGORY_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_CATEGORY_SUCCESS](state, payload) {
    state.category = payload;
    state.loading = false;
  },

  [GET_CATEGORY_BYID](state) {
    state.categoryById = false;
    state.error = false;
    state.loading = true;
  },
  [GET_CATEGORY_BYID_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_CATEGORY_BYID_SUCCESS](state, payload) {
    state.categoryById = payload;
    state.loading = false;
  },

  [CREATE_CATEGORY](state) {
    state.categoryError = false;
    state.success = false;
    state.formLoading = true;
  },
  [CREATE_CATEGORY_ERROR](state, payload) {
    state.categoryError = payload;
    state.formLoading = false;
  },
  [CREATE_CATEGORY_SUCCESS](state, payload) {
    state.category = payload;
    state.success = true;
    state.formLoading = false;
  },

  [GET_ALL_NEWS](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_ALL_NEWS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_ALL_NEWS_SUCCESS](state, payload) {
    state.allnews = payload.data;
    state.paging = payload.paging;
    state.loading = false;
  },

  [SAVE_NEWS](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_NEWS_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [SAVE_NEWS_SUCCESS](state, payload) {
    state.news = payload;
    state.preventNew = false;
    state.success = true;
    state.formLoading = false;
  },

  [CREATE_NEWS](state) {
    state.error = false;
    state.success = false;
    state.loading = true;
    state.newsCreated = 0;
  },
  [CREATE_NEWS_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [CREATE_NEWS_SUCCESS](state, payload) {
    state.success = true;
    state.loading = false;
    state.newsCreated = payload;
  },

  // single object item mutation
  updateItem(state, payload) {
    state.news[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/News/mutations.js